import { render, staticRenderFns } from "./AppVolumeControl.vue?vue&type=template&id=587c032d&scoped=true&"
import script from "./AppVolumeControl.vue?vue&type=script&lang=ts&"
export * from "./AppVolumeControl.vue?vue&type=script&lang=ts&"
import style0 from "./AppVolumeControl.vue?vue&type=style&index=0&id=587c032d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c032d",
  null
  
)

export default component.exports